import { createRouter, createWebHistory } from "vue-router";
import { initCredentials, getUserSessionCookie } from "@/utils/Auth";
import { initCheckMaintenance } from "@/utils/MaintenanceHelper";

import Ce001 from "@/views/Ce001";
import Ce002 from "@/views/Ce002";
import Ce003 from "@/views/Ce003";
import Ce004 from "@/views/Ce004";
import Ce005 from "@/views/Ce005";
import Ce006 from "@/views/Ce006";
import Sv001 from "@/views/Sv001";
import Sv002 from "@/views/Sv002";
import Sv003 from "@/views/Sv003";
import Sv006 from "@/views/Sv006";
import Sv007 from "@/views/Sv007";
import Sv008 from "@/views/Sv008";
import Sv009 from "@/views/Sv009";
import Sv010 from "@/views/Sv010";
import Sv011 from "@/views/Sv011";
import Sv012 from "@/views/Sv012";
import Sv013 from "@/views/Sv013";
import Sv014 from "@/views/Sv014";
import Sv016 from "@/views/Sv016";
import Sv018 from "@/views/Sv018";
import Sv019 from "@/views/Sv019";
import Sv021 from "@/views/Sv021";
import Sv022 from "@/views/Sv022";
import Sv023 from "@/views/Sv023";
import Sv024 from "@/views/Sv024";
import Sv025 from "@/views/Sv025";
import Sv026 from "@/views/Sv026";
import Sv027 from "@/views/Sv027";
import Sv029 from "@/views/Sv029";
import Sv030 from "@/views/Sv030";
// import Sv031 from '@/views/Sv031'
// import Sv032 from '@/views/Sv032'
// import Sv033 from '@/views/Sv033'
// import Sv034 from '@/views/Sv034'
// import Sv035 from '@/views/Sv035'
import Sv036 from "@/views/Sv036";
import Sv039 from "@/views/Sv039";
import Sv042 from "@/views/Sv042";
import Sv043 from "@/views/Sv043";
import Sv044 from "@/views/Sv044";
import Sv045 from "@/views/Sv045";
import Sv046 from "@/views/Sv046";
import Sv047 from "@/views/Sv047";
import Sv052 from "@/views/Sv052";
import Sv053 from "@/views/Sv053";
import Sv057 from "@/views/Sv057";
import Sv059 from "@/views/Sv059";
import Sv060 from "@/views/Sv060";
import En001 from "@/views/En001";
import En002 from "@/views/En002";
import En003 from "@/views/En003";
import En004 from "@/views/En004";
import En005 from "@/views/En005";
import En006 from "@/views/En006";
import En007 from "@/views/En007";
import En008 from "@/views/En008";
import En009 from "@/views/En009";
import En010 from "@/views/En010";
import En011 from "@/views/En011";
import En012 from "@/views/En012";
import En013 from "@/views/En013";
import En014 from "@/views/En014";
import En015 from "@/views/En015";
import En016 from "@/views/En016";
import En017 from "@/views/En017";
import En018 from "@/views/En018";
import En019 from "@/views/En019";
import En020 from "@/views/En020";
import En021 from "@/views/En021";
import En022 from "@/views/En022";
import En023 from "@/views/En023";
import En024 from "@/views/En024";
import En025 from "@/views/En025";
import En026 from "@/views/En026";
import En027 from "@/views/En027";
import En028 from "@/views/En028";
import Cp001 from "@/views/Cp001";
import Mb001 from "@/views/Mb001";
import Mb002 from "@/views/Mb002";
import Mb003 from "@/views/Mb003";
import Mb004 from "@/views/Mb004";
import Mb010 from "@/views/Mb010";
import Mb011 from "@/views/Mb011";
import Mb012 from "@/views/Mb012";
import Mb013 from "@/views/Mb013";
import Mb014 from "@/views/Mb014";
import Mb015 from "@/views/Mb015";
import Mb019 from "@/views/Mb019";
import Mb020 from "@/views/Mb020";
import Mb021 from "@/views/Mb021";
import Mb023 from "@/views/Mb023";
import Mb024 from "@/views/Mb024";
import Mb025 from "@/views/Mb025";
import Mb026 from "@/views/Mb026";
import Mb027 from "@/views/Mb027";
import Mb028 from "@/views/Mb028";
import Mb029 from "@/views/Mb029";
import Mb031 from "@/views/Mb031";
import Mb032 from "@/views/Mb032";
import Mb034 from "@/views/Mb034";
import Mb035 from "@/views/Mb035";
import Mb036 from "@/views/Mb036";
import Mb037 from "@/views/Mb037";
import Mb038 from "@/views/Mb038";
import Mb041 from "@/views/Mb041";
import Mb042 from "@/views/Mb042";
import Mb043 from "@/views/Mb043";
import Mb044 from "@/views/Mb044";
import Mb052 from "@/views/Mb052";
import Mb060 from "@/views/Mb060";
import Mb061 from "@/views/Mb061";
import Mb062 from "@/views/Mb062";
import Mb063 from "@/views/Mb063";
import Mb065 from "@/views/Mb065";
import Mb066 from "@/views/Mb066";
import Nw001 from "@/views/Nw001";
import Nw003 from "@/views/Nw003";
import Nw005 from "@/views/Nw005";
// import Nw007 from '@/views/Nw007'
import Tem001 from "@/views/Tem001";
import Tem002 from "@/views/Tem002";
import Tem003 from "@/views/Tem003";
import Tem004 from "@/views/Tem004";
import Tem005 from "@/views/Tem005";
import Tem006 from "@/views/Tem006";
import Tem007 from "@/views/Tem007";
import Tem008 from "@/views/Tem008";
import Tem012 from "@/views/Tem012";
import Tem013 from "@/views/Tem013";
import Tem014 from "@/views/Tem014";
import Tem015 from "@/views/Tem015";
import Tem017 from "@/views/Tem017";
import Tem018 from "@/views/Tem018";
import Tem019 from "@/views/Tem019";
import Tem021 from "@/views/Tem021";
import Tem022 from "@/views/Tem022";
import Tem024 from "@/views/Tem024";
import Tem025 from "@/views/Tem025";
import Tem026 from "@/views/Tem026";
import Tem027 from "@/views/Tem027"; // メンテナンス中（会員サイト/サービスサイト）
import Tem028 from "@/views/Tem028"; // お探しのページが見つかりませんでした
import Tem029 from "@/views/Tem029"; // ページを表示できません
import Tem030 from "@/views/Tem030"; // タイムアウトエラー
import Tem031 from "@/views/Tem031"; // メンテナンス中(会員サイト)
import Tem032 from "@/views/Tem032"; // メンテナンス中(サービスサイト）
import Tem040 from "@/views/Tem040";
import CmsTemplate from "@/views/Sv001"; //CmsTemplate";

// 個人情報保護方針
// import Sv037 from '@/views/Sv037'
// サイトのご利用にあたり
// import Sv038 from '@/views/Sv038'

// import checkSessionTimeOut from '@/utils/Auth'
import EntryLayout from "@/components/layouts/EntryLayout";
import ServiceLayout from "@/components/layouts/ServiceLayout";
import MemberLayout from "@/components/layouts/MemberLayout";

const routes = [
  {
    path: "/cms",
    component: ServiceLayout,
    children: [
      {
        path: "cmstemplate",
        name: "cmstemplate",
        component: CmsTemplate,
      },
    ],
  },
  {
    path: "/",
    component: ServiceLayout,
    children: [
      {
        path: "",
        name: "sv001",
        component: Sv001,
      },
      {
        path: "",
        name: "root",
        component: Sv001,
      },
      {
        path: "about",
        name: "sv002",
        component: Sv002,
      },
      {
        path: "profit",
        name: "sv003",
        component: Sv003,
      },
      {
        path: "method",
        name: "sv042",
        component: Sv042,
      },
      {
        path: "basic",
        name: "sv043",
        component: Sv043,
      },
      {
        path: "au-service",
        name: "sv044",
        component: Sv044,
      },
      {
        path: "apply",
        name: "sv045",
        component: Sv045,
      },
      {
        path: "loan",
        name: "sv046",
        component: Sv046,
      },
      {
        path: "repayment",
        name: "sv047",
        component: Sv047,
      },
      {
        path: "topics",
        name: "nw001",
        component: Nw001,
      },
      {
        path: "notice",
        name: "nw003",
        component: Nw003,
      },
      {
        path: "news",
        name: "nw005",
        component: Nw005,
      },
      // {
      //   path: 'urgent',
      //   name: 'nw007',
      //   component: Nw007
      // },
      {
        path: "campaign",
        name: "cp001",
        component: Cp001,
      },
      {
        path: "inquiry",
        name: "sv036",
        component: Sv036,
      },
      {
        path: "sitemap",
        name: "sv039",
        component: Sv039,
      },
    ],
  },
  {
    path: "/method",
    component: ServiceLayout,
    children: [
      {
        path: "001",
        name: "sv006",
        component: Sv006,
      },
      {
        path: "002",
        name: "sv007",
        component: Sv007,
      },
      {
        path: "003",
        name: "sv053",
        component: Sv053,
      },
      {
        path: "004",
        name: "sv008",
        component: Sv008,
      },
    ],
  },
  {
    path: "/basic",
    component: ServiceLayout,
    children: [
      {
        path: "001",
        name: "sv009",
        component: Sv009,
      },
      {
        path: "002",
        name: "sv010",
        component: Sv010,
      },
      {
        path: "003",
        name: "sv011",
        component: Sv011,
      },
      {
        path: "004",
        name: "sv012",
        component: Sv012,
      },
    ],
  },
  {
    path: "/au-service",
    component: ServiceLayout,
    children: [
      {
        path: "001",
        name: "sv013",
        component: Sv013,
      },
      {
        path: "002",
        name: "sv014",
        component: Sv014,
      },
      {
        path: "003",
        name: "sv016",
        component: Sv016,
      },
    ],
  },
  {
    path: "/apply",
    component: ServiceLayout,
    children: [
      {
        path: "list",
        name: "sv018",
        component: Sv018,
      },
      {
        path: "documents",
        name: "sv019",
        component: Sv019,
      },
      {
        path: "income",
        name: "sv057",
        component: Sv057,
      },
      {
        path: "member-use",
        name: "sv059",
        component: Sv059,
      },
      {
        path: "check",
        name: "sv021",
        component: Sv021,
      },
    ],
  },
  {
    path: "/loan",
    component: ServiceLayout,
    children: [
      {
        path: "interest",
        name: "sv022",
        component: Sv022,
      },
      {
        path: "transfer",
        name: "sv023",
        component: Sv023,
      },
      {
        path: "charge",
        name: "sv024",
        component: Sv024,
      },
      {
        path: "atm",
        name: "sv025",
        component: Sv025,
      },
      {
        path: "devauth",
        name: "sv060",
        component: Sv060,
      },
    ],
  },
  {
    path: "/repayment",
    component: ServiceLayout,
    children: [
      {
        path: "simulation",
        name: "sv052",
        component: Sv052,
      },
      {
        path: "withdraw",
        name: "sv026",
        component: Sv026,
      },
      {
        path: "prepayment",
        name: "sv027",
        component: Sv027,
      },
      {
        path: "atm",
        name: "sv029",
        component: Sv029,
      },
    ],
  },
  {
    path: "/agreement",
    component: ServiceLayout,
    children: [
      {
        path: "",
        name: "sv030",
        component: Sv030,
      },
    ],
  },
  {
    path: "/entry",
    component: EntryLayout,
    children: [
      {
        path: "agreement",
        name: "en001",
        component: En001,
      },
      {
        path: "account",
        name: "en006",
        component: En006,
        meta: { checkUserSession: true },
      },
      {
        path: "upload",
        name: "en007",
        component: En007,
        meta: { checkUserSession: true },
      },
      {
        path: "income",
        name: "en017",
        component: En017,
        meta: { checkUserSession: true },
      },
      {
        path: "secret",
        name: "en015",
        component: En015,
        meta: { checkUserSession: true },
      },
      {
        path: "reupload",
        name: "en026",
        component: En026,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/entry/form",
    component: EntryLayout,
    children: [
      {
        path: "customer001",
        name: "en002",
        component: En002,
        meta: { checkUserSession: true },
      },
      {
        path: "customer002",
        name: "en003",
        component: En003,
        meta: { checkUserSession: true },
      },
      {
        path: "customer003",
        name: "en004",
        component: En004,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "en005",
        component: En005,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/entry/account",
    component: EntryLayout,
    children: [
      {
        path: "ok",
        name: "tem002",
        component: Tem002,
        meta: { checkUserSession: true },
      },
      {
        path: "ng",
        name: "tem003",
        component: Tem003,
        meta: { checkUserSession: true },
      },
      {
        path: "error",
        name: "tem004",
        component: Tem004,
        meta: { checkUserSession: true },
      },
      {
        path: "cancel",
        name: "tem005",
        component: Tem005,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem006",
        component: Tem006,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/entry/upload",
    component: EntryLayout,
    children: [
      {
        path: "select",
        name: "en008",
        component: En008,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "en009",
        component: En009,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem001",
        component: Tem001,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/entry/reupload",
    component: EntryLayout,
    children: [
      {
        path: "select",
        name: "en027",
        component: En027,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "en028",
        component: En028,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem025",
        component: Tem025,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/entry/result",
    component: EntryLayout,
    children: [
      {
        path: "upload",
        name: "en020",
        component: En020,
        meta: { checkUserSession: true },
      },
      {
        path: "account",
        name: "en021",
        component: En021,
        meta: { checkUserSession: true },
      },
      {
        path: "001",
        name: "en022",
        component: En022,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "en012",
        component: En012,
        meta: { checkUserSession: true },
      },
      {
        path: "002",
        name: "en010",
        component: En010,
        meta: { checkUserSession: true },
      },
      {
        path: "003",
        name: "en011",
        component: En011,
        meta: { checkUserSession: true },
      },
      {
        path: "done",
        name: "en013",
        component: En013,
        meta: { checkUserSession: true },
      },
      {
        path: "failure",
        name: "en014",
        component: En014,
      },
    ],
  },
  {
    path: "/entry/income",
    component: EntryLayout,
    children: [
      {
        path: "select",
        name: "en018",
        component: En018,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "en019",
        component: En019,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem022",
        component: Tem022,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/entry/secret",
    component: EntryLayout,
    children: [
      {
        path: "confirmation",
        name: "en016",
        component: En016,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem021",
        component: Tem021,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/entry/error",
    component: EntryLayout,
    children: [
      {
        path: "001",
        name: "en023",
        component: En023,
      },
      {
        path: "002",
        name: "en024",
        component: En024,
      },
      {
        path: "003",
        name: "en025",
        component: En025,
      },
    ],
  },
  {
    path: "/member",
    component: MemberLayout,
    children: [
      {
        path: "",
        name: "mb001",
        component: Mb001,
        meta: { checkUserSession: true },
      },
      {
        path: "transfer",
        name: "mb011",
        component: Mb011,
        meta: { checkUserSession: true },
      },
      {
        path: "charge",
        name: "mb012",
        component: Mb012,
        meta: { checkUserSession: true },
      },
      {
        path: "agreement",
        name: "mb019",
        component: Mb019,
        meta: { checkUserSession: true },
      },
      {
        path: "documents",
        name: "mb020",
        component: Mb020,
        meta: { checkUserSession: true },
      },
      {
        path: "income",
        name: "mb041",
        component: Mb041,
        meta: { checkUserSession: true },
      },
      {
        path: "simulation",
        name: "mb052",
        component: Mb052,
        meta: { checkUserSession: true },
      },
      {
        path: "details",
        name: "mb004",
        component: Mb004,
        meta: { checkUserSession: true },
      },
      {
        path: "inquiry",
        name: "mb023",
        component: Mb023,
        meta: { checkUserSession: true },
      },
      {
        path: "account",
        name: "mb021",
        component: Mb021,
        meta: { checkUserSession: true },
      },
      {
        path: "upload",
        name: "mb038",
        component: Mb038,
        meta: { checkUserSession: true },
      },
      {
        path: "password",
        name: "mb010",
        component: Mb010,
        meta: { checkUserSession: true },
      },
      {
        path: "onetimepass",
        name: "mb060",
        component: Mb060,
        meta: { checkUserSession: true },
      },
      {
        path: "onetimepass/form",
        name: "mb061",
        component: Mb061,
        meta: { checkUserSession: true },
      },
      {
        path: "bankauth",
        name: "mb062",
        component: Mb062,
        meta: { checkUserSession: true },
      },
      {
        path: "bankauth/lock",
        name: "mb063",
        component: Mb063,
      },
      {
        path: "phone/form",
        name: "mb065",
        component: Mb065,
        meta: { checkUserSession: true },
      },
      {
        path: "phone/confirmation",
        name: "mb066",
        component: Mb066,
        meta: { checkUserSession: true },
      },
      {
        path: "phone/complete",
        name: "tem040",
        component: Tem040,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member",
    component: EntryLayout,
    children: [
      {
        path: "logout",
        name: "tem024",
        component: Tem024,
      },
      {
        path: "quit",
        name: "mb044",
        component: Mb044,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/transfer",
    component: MemberLayout,
    children: [
      {
        path: "confirmation",
        name: "mb013",
        component: Mb013,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem007",
        component: Tem007,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/charge",
    component: MemberLayout,
    children: [
      {
        path: "confirmation",
        name: "mb014",
        component: Mb014,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem008",
        component: Tem008,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/return",
    component: MemberLayout,
    children: [
      {
        path: "transfer",
        name: "mb015",
        component: Mb015,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/change",
    component: MemberLayout,
    children: [
      {
        path: "form",
        name: "mb024",
        component: Mb024,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "mb027",
        component: Mb027,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem017",
        component: Tem017,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/occupation",
    component: MemberLayout,
    children: [
      {
        path: "form",
        name: "mb025",
        component: Mb025,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "mb028",
        component: Mb028,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem018",
        component: Tem018,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/e-mail",
    component: MemberLayout,
    children: [
      {
        path: "form",
        name: "mb026",
        component: Mb026,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "mb029",
        component: Mb029,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem019",
        component: Tem019,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/income",
    component: MemberLayout,
    children: [
      {
        path: "select",
        name: "mb042",
        component: Mb042,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "mb043",
        component: Mb043,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "tem026",
        component: Tem026,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/account",
    component: EntryLayout,
    children: [
      {
        path: "001",
        name: "tem012",
        component: Tem012,
        meta: { checkUserSession: true },
      },
      {
        path: "002",
        name: "tem013",
        component: Tem013,
        meta: { checkUserSession: true },
      },
      {
        path: "003",
        name: "tem014",
        component: Tem014,
        meta: { checkUserSession: true },
      },
      {
        path: "004",
        name: "tem015",
        component: Tem015,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/password",
    component: MemberLayout,
    children: [
      {
        path: "form",
        name: "mb031",
        component: Mb031,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "mb032",
        component: Mb032,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "mb034",
        component: Mb034,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/upload",
    component: MemberLayout,
    children: [
      {
        path: "select",
        name: "mb035",
        component: Mb035,
        meta: { checkUserSession: true },
      },
      {
        path: "confirmation",
        name: "mb036",
        component: Mb036,
        meta: { checkUserSession: true },
      },
      {
        path: "complete",
        name: "mb037",
        component: Mb037,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member/message",
    component: MemberLayout,
    children: [
      {
        path: "detail/:notice_id",
        name: "mb003",
        component: Mb003,
        meta: { checkUserSession: true },
      },
      {
        path: "detail",
        name: "mb003-template",
        component: Mb003,
        meta: { checkUserSession: true },
      },
      {
        path: "top",
        name: "mb002",
        component: Mb002,
        meta: { checkUserSession: true },
      },
    ],
  },
  {
    path: "/member",
    component: ServiceLayout,
    children: [
      {
        path: "login-id",
        name: "ce001",
        component: Ce001,
      },
    ],
  },
  {
    path: "/member/login-id",
    component: EntryLayout,
    children: [
      {
        path: "login",
        name: "ce002",
        component: Ce002,
      },
      {
        path: "idenrification",
        name: "ce003",
        component: Ce003,
      },
      {
        path: "form",
        name: "ce006",
        component: Ce006,
      },
      {
        path: "confirmation",
        name: "ce004",
        component: Ce004,
      },
      {
        path: "complete",
        name: "ce005",
        component: Ce005,
      },
    ],
  },
  {
    path: "/action",
    component: EntryLayout,
    children: [
      { path: "timeout", name: "SessionTimeOut", component: Tem030 },
      { path: "timeout", name: "er002", component: Tem030 },
      { path: "500", name: "InternalServerError", component: Tem029 },
      { path: "500", name: "er001", component: Tem029 },
      { path: "maintenance3", name: "ServiceUnavailable", component: Tem027 },
      { path: "maintenance3", name: "er003", component: Tem027 },
      { path: "maintenance1", name: "er004", component: Tem031 },
      { path: "maintenance2", name: "er005", component: Tem032 },
      { path: "404", name: "NotFound", component: Tem028 },
    ],
  },
  {
    path: "/",
    component: EntryLayout,
    children: [{ path: "*", component: Tem028 }],
  },
  // {
  //   path: '/sv',
  //   component: ServiceLayout,
  //   children: [
  //     // {
  //     //   path: 'sv037',
  //     //   name: 'sv037',
  //     //   component: Sv037
  //     // },
  //     // {
  //     //   path: 'sv038',
  //     //   name: 'sv038',
  //     //   component: Sv038
  //     // },
  //   ]
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // console.log("to.name", to.name);
  // console.log('to.path', to.path)
  // console.log("checkUserSession", to.meta.checkUserSession);
  // 定義されていないページへのアクセスの場合は404へ遷移
  if (to.name === undefined) {
    next({ name: "NotFound" });
    return;
  }
  if (to.meta.checkUserSession && !getUserSessionCookie()) {
    // user_sessionが必要なページでuser_sessionを持っていない場合
    if (
      window.__PRERENDER_INJECTED &&
      window.__PRERENDER_INJECTED.isPrerendering
    ) {
      // PRERENDER時はスキップ
    } else {
      next({ name: "SessionTimeOut" });
      return;
    }
  }
  if (to.path.match(/\/index\.html?$/)) {
    // index.htmlが付いていた場合削除する
    next({ path: to.path.replace(/\/index\.html?$/, "/") });
  }
  if (!to.meta.checkUserSession) {
    // user_sessionが不要なページはメンテナンスチェックのみ行う
    let toName = to.name.toUpperCase();
    let matchs = toName.match(/(CE|CP|SV|EN|NW|MB|TEM)(\d+)/);
    if (!matchs) {
      next();
      return;
    }
    let pageId = matchs[1] + "-" + matchs[2];
    initCheckMaintenance(pageId).then(
      (res) => {
        if (res !== undefined && res.check_result === "NG") {
          let pageName = res.redirect_page.toLowerCase().replace("-", "");
          return next({ name: pageName });
        }
      },
      () => {
        // console.error('reason', reason)
        if (process.env.NODE_ENV === "development") {
          return next();
        }
        next({ name: "InternalServerError" });
      }
    );
    next();
    return;
  }
  if (!to.name) {
    next();
    return;
  }
  let toName = to.name.toUpperCase();
  let matchs = toName.match(/(CE|CP|SV|EN|NW|MB|TEM)(\d+)/);
  if (!matchs) {
    next();
    return;
  }
  let pageId = matchs[1] + "-" + matchs[2];
  const authKind = to.query?.auth_kind;
  // console.log('pageId', pageId)
  initCredentials(pageId, authKind).then(
    (res) => {
      if (res && res.redirect_page) {
        switch (res.redirect_page) {
          case "MB-010-profile":
            return next({
              name: "mb010",
              query: { auth_kind: "profile", page_id: "mb024" },
            });
          case "MB-010-workplace":
            return next({
              name: "mb010",
              query: { auth_kind: "workplace", page_id: "mb025" },
            });
          case "MB-010-mailaddress":
            return next({
              name: "mb010",
              query: { auth_kind: "mailaddress", page_id: "mb026" },
            });
          case "MB-010-repayments":
            return next({
              name: "mb010",
              query: { auth_kind: "repayments", page_id: "mb011" },
            });
          case "MB-010-borrowing":
            return next({
              name: "mb010",
              query: { auth_kind: "borrowing", page_id: "mb012" },
            });
          case "MB-060-profile":
            return next({
              name: "mb060",
              query: { auth_kind: "profile", page_id: "mb024" },
            });
          case "MB-060-workplace":
            return next({
              name: "mb060",
              query: { auth_kind: "workplace", page_id: "mb025" },
            });
          case "MB-060-mailaddress":
            return next({
              name: "mb060",
              query: { auth_kind: "mailaddress", page_id: "mb026" },
            });
          case "MB-060-repayments":
            return next({
              name: "mb060",
              query: { auth_kind: "repayments", page_id: "mb011" },
            });
          case "MB-060-borrowing":
            return next({
              name: "mb060",
              query: { auth_kind: "borrowing", page_id: "mb012" },
            });
        }
        let pageName = res.redirect_page.toLowerCase().replace("-", "");
        // console.log('redirect_page', pageName)
        return next({ name: pageName });
      }
      next();
    },
    () => {
      // console.error('reason', reason)
      if (process.env.NODE_ENV === "development") {
        return next();
      }
      next({ name: "InternalServerError" });
    }
  );
});

export default router;

export const navSvAbout = ["sv002"];

export const navSvRecipe = [
  "sv003",
  "sv043",
  "sv042",
  "sv044",
  "sv009",
  "sv010",
  "sv011",
  "sv012",
  "sv006",
  "sv007",
  "sv053",
  "sv008",
];

export const navSvEntry = [
  "sv045",
  "sv018",
  "sv019",
  "sv057",
  "sv059",
  "sv021",
];

export const navSvBorrow = ["sv046", "sv022", "sv023", "sv024", "sv025"];

export const navSvReturn = ["sv047", "sv052", "sv026", "sv027", "sv029"];

export const navMbTop = ["mb001"];

export const navMbHistory = ["mb004"];

export const navMbBorrow = [
  "mb011",
  "mb013",
  "tem007",
  "mb012",
  "mb014",
  "tem008",
];

export const navMbReturn = ["mb015"];

export const navMbLoan = ["mb019", "mb020", "mb004"];

export const navMbMypage = [
  "mb023",
  "mb024",
  "mb027",
  "tem017",
  "mb025",
  "mb028",
  "tem018",
  "mb026",
  "mb029",
  "tem019",
  "mb021",
  "tem012",
  "tem013",
  "tem014",
  "tem015",
  "mb031",
  "mb032",
  "mb034",
  "mb038",
  "mb035",
  "mb036",
  "mb037",
];

export const auWalletPages = [
  "mb010",
  "mb032",
  "mb031",
  "mb034",
  "mb012",
  "mb014",
  "tem008",
];
